var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2607 22.9393L12.1213 12.8L12.8 12.1213L22.9393 22.2607L24 23.3213L25.0607 22.2607L35.2 12.1213L35.8787 12.8L25.7393 22.9393L24.6787 24L25.7393 25.0607L35.8787 35.2L35.2 35.8787L25.0607 25.7393L24 24.6787L22.9393 25.7393L12.8 35.8787L12.1213 35.2L22.2607 25.0607L23.3213 24L22.2607 22.9393Z",
    stroke: "#B55D51",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cb718d01f4fbe62d0ec959b4657d42d1.svg";
export { ForwardRef as ReactComponent };